import { jsx as p, jsxs as g, Fragment as M } from "react/jsx-runtime";
import { EditorMenuContent as V } from "../../shared/editor-menu-content/EditorMenuContent.component.js";
import { LabeledSelect as E } from "../../shared/labeled-select/LabeledSelect.component.js";
import { useInput as s, equalsWhenLowerCased as C } from "../../shared/utils.js";
import { T as v, S as m } from "../../index-LgiXwH_r.js";
import { useMemo as T, useCallback as x } from "react";
import { mapTriggerEnumToLabel as D } from "./utils.js";
import '../../assets/TriggerForm.css';const F = "_inputs_19kiq_1", j = {
  inputs: F
}, d = (e, t, o) => e === "INSERT" ? !Object.values(o).some(
  (n) => n.type === m.batchCreateType || n.type === m.createType && C(n.params.ofType, t)
) : e === "REMOVE" ? !Object.values(o).some(
  (n) => n.type === m.deleteType && C(n.params.ofType, t)
) : !0, W = ({
  copies: e,
  close: t,
  onAddTrigger: o,
  apiDeclaration: n,
  declaration: l
}) => {
  const {
    value: a,
    onInput: I,
    setError: f,
    error: O
  } = s(null), {
    value: r,
    onInput: y,
    setError: b,
    error: R
  } = s(null), {
    value: u,
    onInput: _,
    setError: h,
    error: L
  } = s(null), c = T(
    () => [v.TABLE_DATA_CHANGE].map((i) => ({
      value: i,
      label: D(
        v.TABLE_DATA_CHANGE,
        e
      )
    })),
    [e]
  ), q = T(
    () => {
      var i;
      return [
        ...((i = n.types) == null ? void 0 : i.map((A) => ({
          value: A.id,
          label: A.name
        }))) ?? [],
        {
          value: "filedocument",
          label: "FileDocument"
        },
        {
          value: "cloudfunction",
          label: "CloudFunction"
        }
      ];
    },
    [n.types]
  ), N = T(
    () => [
      ...r != null && r.value && d("INSERT", r == null ? void 0 : r.value, l.steps) ? [
        {
          value: "INSERT",
          label: e.insert
        }
      ] : [],
      ...r != null && r.value && d("MODIFY", r == null ? void 0 : r.value, l.steps) ? [
        {
          value: "MODIFY",
          label: e.modify
        }
      ] : [],
      ...r != null && r.value && d("REMOVE", r == null ? void 0 : r.value, l.steps) ? [
        {
          value: "REMOVE",
          label: e.remove
        }
      ] : []
    ],
    [e, r, l.steps]
  ), S = x(() => {
    if ((a == null ? void 0 : a.value) === v.TABLE_DATA_CHANGE) {
      if (!r) {
        b(e.tableRequiredError);
        return;
      }
      if (!u) {
        h(e.operationRequiredError);
        return;
      }
      o({
        variant: a.value,
        operation: u.value,
        tableId: r.value
      });
    }
    if (!a) {
      f(e.variantRequiredError);
      return;
    }
    t();
  }, [
    t,
    e.operationRequiredError,
    e.tableRequiredError,
    e.variantRequiredError,
    o,
    u,
    h,
    b,
    f,
    r,
    a
  ]);
  return /* @__PURE__ */ p(V, { onSave: S, copies: e, close: t, children: /* @__PURE__ */ g("div", { className: j.inputs, children: [
    /* @__PURE__ */ p(
      E,
      {
        labelText: e.variantInputLabel,
        placeholder: e.variantInputPlaceholder,
        options: c,
        id: "flowTriggerVariant",
        error: O,
        onChange: I,
        value: a
      }
    ),
    (a == null ? void 0 : a.value) === v.TABLE_DATA_CHANGE && /* @__PURE__ */ g(M, { children: [
      /* @__PURE__ */ p(
        E,
        {
          labelText: e.tableInputLabel,
          placeholder: e.tableInputPlaceholder,
          options: q,
          id: "flowTriggerTable",
          error: R,
          onChange: y,
          value: r
        }
      ),
      /* @__PURE__ */ p(
        E,
        {
          labelText: e.optionLabel,
          placeholder: e.operationInputPlaceholder,
          options: N,
          id: "flowTriggerOption",
          error: L,
          onChange: _,
          value: u
        }
      )
    ] })
  ] }) });
};
export {
  W as TriggerForm
};
